/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Dropbox_Search_ResultsInputs */

const en_dropbox_search_results = /** @type {(inputs: Dropbox_Search_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Results for “${i?.query}”`)
};

const es_dropbox_search_results = /** @type {(inputs: Dropbox_Search_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resultados de «${i?.query}»`)
};

/**
* | output |
* | --- |
* | "Results for “{query}”" |
*
* @param {Dropbox_Search_ResultsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_search_results = /** @type {((inputs: Dropbox_Search_ResultsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Search_ResultsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_search_results(inputs)
	return en_dropbox_search_results(inputs)
});